


























import { Component, Vue } from 'vue-property-decorator'
import { IAppFeature, EFeatureStatus } from '@/apps/open/types/app'
import { getApplyFeatureList, getFeatureList, applyFeature } from '@/apps/open/services/app'
import { onRequestError } from '@/apps/open/utils'
import EmailAdminDialogBody from '@/apps/open/components/DialogBodys/EmailAdmin.vue'

@Component
export default class AppPermission extends Vue {
  features: IAppFeature[] = []
  app_id = ''

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  mounted () {
    this.app_id = this.$route.params['id']
    this.features = []
    Promise.all([getFeatureList(this.app_id), getApplyFeatureList(this.app_id)])
      .then(values => {
        let all: IAppFeature[] = values[0].data.object_array
        let apply: IAppFeature[] = values[1].data.object_array
        for (let i of all) {
          i.status = EFeatureStatus.NoApply
          for (let j of apply) {
            if (i.function_id === j.function_id) {
              i = { ...i, ...j }
              break
            }
          }
          this.features.push({ ...i })
        }
      }).catch((error) => {
        onRequestError(error)
      })
  }

  getStatusText (status: number) {
    switch (status) {
      case EFeatureStatus.Passed:
        return '已获取'

      case EFeatureStatus.Pending:
        return '申请中'

      case EFeatureStatus.Rejected:
      case EFeatureStatus.Refused:
        return '未通过'
    }
    return ''
  }

  isNoApply (status: number) {
    return status === EFeatureStatus.NoApply
  }

  isPassed (status: number) {
    return status === EFeatureStatus.Passed
  }

  isPending (status: number) {
    return status === EFeatureStatus.Pending
  }

  isRejected (status: number) {
    return status === EFeatureStatus.Rejected || status === EFeatureStatus.Refused
  }

  showEmailAdminDialog (function_id: number) {
    this.$dialog.show({
      title: '邮件管理',
      body: EmailAdminDialogBody,
      bodyProps: {
        function_id,
        is_wwo: false
      }
    })
  }

  applyFeature (item: IAppFeature) {
    const h: any = this.$createElement
    this.$msgbox({
      title: '你将申请以下功能的权限：',
      message: h('p', null, this.isPrivate ? `${item.function_name}` : [
        `${item.function_name}，请联系`,
        h('a', {
          on: {
            click: () => this.toDocs('/docs/cloud/FAQ#des13')
          },
          style: 'color: #409EFF; text-decoration: none; cursor: pointer;'
        }, ' 管理员 '),
        '审批'
      ]),
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }).then(() => {
      applyFeature(this.app_id, item.function_id || '')
        .then(() => {
          item.status = EFeatureStatus.Pending
        }).catch((error) => {
          onRequestError(error)
        })
    })
  }

  toDocs (url: string) {
    if (url) {
      if (this.isPrivate) {
        window.open(`#${url}`)
      } else {
        if (/^(https:\/\/open.wps.cn)/.test(url)) {
          url = url.split('https://open.wps.cn')[1]
        }
        window.open(url)
      }
    }
  }
}
